// extracted by mini-css-extract-plugin
module.exports = {"shareBtn":"ShareBtn_shareBtn__E9PM_"};